import { isEmpty } from '@ember/utils';
import Model, { attr } from '@ember-data/model';

export default class AdminUser extends Model {
  @attr('string') declare firstName: string;
  @attr('string') lastName?: string;
  @attr('string') declare email: string;
  @attr('string') declare role: string;
  @attr('boolean') declare billable: boolean;
  @attr('date') declare createdAt: Date;
  @attr('date') declare currentSignInAt: Date;
  @attr('string') selectedFundId?: string;
  @attr('string') activationCode?: string;
  @attr() fundIds?: string[] | undefined;

  get displayName() {
    let { firstName, lastName } = this;
    if (isEmpty(lastName)) {
      return firstName;
    } else {
      return `${lastName}, ${firstName}`;
    }
  }

  get displayNameLowerCase() {
    return this.displayName.toLowerCase();
  }

  get nameAndEmailLowerCase() {
    let { firstName, lastName, email } = this;
    return `${firstName?.toLowerCase()} ${lastName?.toLowerCase()} ${email.toLowerCase()}`;
  }

  get emailLowerCase() {
    return (this.email || '').toLowerCase();
  }
}
